var selectmenuPlaceholderHandler = function($el, val, def) {
  if (val === def || (!def && !val)) {
    $el.addClass('has-placeholder');
  } else {
    $el.removeClass('has-placeholder');
  }
};

var selectmenuChangeHandler = function(ev, ui) {
  var $select = $(ev.target);

  selectmenuPlaceholderHandler(
    $select.next(),
    $select.val(),
    ($select.data('default') || '') + ''
  );
};

window.addEventListener('load', function() {
  $('.dropdown').each(function() {
    if ($(this).children('.dropdown-toggle').length) {
      /*** BOOTSTRAP DROPDOWN HANDLING ***/
      var $toggle = $(this).children('.dropdown-toggle');
      var $menu = $(this).children('.dropdown-menu');
      var $val = $(this).children('input[type=hidden]');
      var placeholder = $toggle.text();

      $menu.children('a.dropdown-item').click(function(e) {
        e.preventDefault();

        $(this)
          .parent()
          .children('.dropdown-item')
          .removeClass('active');
        $(this).addClass('active');

        if ($(this).data('option')) {
          $toggle.removeClass('has-placeholder').text($(this).text());
        } else {
          $toggle.addClass('has-placeholder').text(placeholder);
        }

        if ($val && $val.length) {
          $val.val($(this).data('option'));
        }
      });
    } else if ($(this).children('.ui-selectmenu-button').length) {
      /*** JQUERY SELECTMENU HANDLING ***/
      var $select = $(this).children('select');
      var defaultValue = ($select.data('default') || '') + '';

      $select
        .on('selectmenucreate', function(ev, ui) {
          selectmenuPlaceholderHandler(
            $(ev.currentTarget).next(),
            $select.val(),
            defaultValue
          );
        })
        .on('selectmenuchange', selectmenuChangeHandler);
    }
  });
});
